/* Shared, local-only Point of View experience. No camera, API calls or measurements. */
(function () {
  "use strict";
  var contexts={everyday:"Everyday",work:"Work",evening:"Evening",travel:"Travel"};
  var moods={quiet:"Understated",bold:"Expressive",classic:"Classic",playful:"Unexpected"};
  function valid(x){return x && contexts[x.context] && moods[x.mood];}
  function mount(root){
    if(root.dataset.vrPovReady==="true")return;
    var form=root.querySelector("[data-pov-form]"),list=root.querySelector("[data-pov-list]");
    var status=root.querySelector("[data-pov-status]"),choice=root.querySelector("[data-pov-choice]");
    var clear=root.querySelector("[data-pov-clear]");
    if(!form||!list||!status||!choice||!clear)return;
    root.dataset.vrPovReady="true";
    var demo=root.hasAttribute("data-pov-demo"),handle=(root.dataset.povHandle||"").slice(0,120);
    var key="vueraith:pov:1:"+location.host+":"+handle, looks=[];
    if(!demo&&handle){try{var found=JSON.parse(localStorage.getItem(key)||"[]");
      if(Array.isArray(found))looks=found.filter(valid).slice(0,4).map(function(x){return{context:x.context,mood:x.mood};});
    }catch(_){}}
    function choiceValue(name){return new FormData(form).get(name);}
    function persist(){if(demo)return true;try{localStorage.setItem(key,JSON.stringify(looks));return true;}catch(_){return false;}}
    function render(){
      list.replaceChildren();
      looks.forEach(function(look){
        var li=document.createElement("li"),name=document.createElement("span"),remove=document.createElement("button");
        name.textContent=contexts[look.context]+" / "+moods[look.mood];
        remove.type="button";remove.textContent="Remove";remove.setAttribute("aria-label","Remove "+contexts[look.context]+" look");
        remove.addEventListener("click",function(){
          looks=looks.filter(function(x){return x.context!==look.context;});
          var saved=persist();render();
          status.textContent=saved?"Look removed.":"Removed from this view, but device storage is unavailable.";
        });
        li.append(name,remove);list.append(li);
      });
      clear.hidden=looks.length===0;
      var empty=root.querySelector("[data-pov-empty]");if(empty)empty.hidden=looks.length>0;
      var count=root.querySelector("[data-pov-count]");if(count)count.textContent=looks.length+" / 4";
    }
    function update(){
      var context=choiceValue("context"),mood=choiceValue("mood");
      if(contexts[context]&&moods[mood])choice.textContent=contexts[context]+" / "+moods[mood];
    }
    form.addEventListener("change",update);
    form.addEventListener("submit",function(event){event.preventDefault();});
    form.querySelector("[data-pov-save]").addEventListener("click",function(){
      var context=choiceValue("context"),mood=choiceValue("mood");
      if(!contexts[context]||!moods[mood]||!handle)return;
      looks=[{context:context,mood:mood}].concat(looks.filter(function(x){return x.context!==context;})).slice(0,4);
      var saved=persist();render();
      status.textContent=demo?"Preview added. This is not saved or published.":
        saved?"Saved only in this browser; no data sent to Vueraith.":"Kept for this visit only; browser storage is unavailable.";
    });
    clear.addEventListener("click",function(){
      looks=[];var saved=true;if(!demo){try{localStorage.removeItem(key);}catch(_){saved=false;}}
      render();status.textContent=saved?"Looks cleared.":"Cleared for this visit only.";
    });
    var fit=root.querySelector("[data-pov-fit]");
    if(fit)fit.textContent=root.dataset.povDimensions==="yes"?
      "Frame dimensions are available. Fit on your face has not been checked.":
      "Not checked. We do not have enough frame measurements to assess fit.";
    update();render();
  }
  function boot(){document.querySelectorAll("[data-vr-point-of-view]").forEach(mount);}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot,{once:true});else boot();
  if(!window.__vrPovEvents){window.__vrPovEvents=true;document.addEventListener("shopify:section:load",boot);}
})();